<template>
  <div id="app">
    <HeaderLayout :has-error="hasError" :corp-param="corpParam"></HeaderLayout>
    <ErrorBoundary v-cloak @occur-error="occurError">
      <NavigationLayout />
      <IndexLayout v-if="!isComplete" @set-corp-param="setCorpParam" />
      <CompleteLayout v-else />
    </ErrorBoundary>
    <FooterLayout :corp-param="corpParam"></FooterLayout>
  </div>
</template>

<script>
import queryString from "query-string";
import IndexLayout from "./components/Index.vue";
import CompleteLayout from "./components/CompleteLayout.vue";
import HeaderLayout from "./components/HeaderLayout.vue";
import FooterLayout from "./components/FooterLayout.vue";
import NavigationLayout from "./components/NavigationLayout.vue";
import ErrorBoundary from "./components/ErrorBoundary.vue";

export default {
  name: "App",
  components: {
    IndexLayout,
    CompleteLayout,
    HeaderLayout,
    FooterLayout,
    NavigationLayout,
    ErrorBoundary,
  },
  data() {
    return {
      hasError: false,
      corpParam: {},
    };
  },
  computed: {
    isComplete() {
      return queryString.parse(window.location.search).complete !== undefined;
    },
  },
  created() {
    this.$logger.info("front-account-registration-for-public is accessed.");
    if (!Object.keys(this.corpParam).length) {
      this.corpParam = JSON.parse(localStorage.getItem("corpParam"));
    }
  },
  methods: {
    occurError() {
      this.hasError = true;
    },
    setCorpParam(param) {
      this.corpParam = param;
    },
  },
};
</script>

<style></style>
